// components/calculator/SummarySection.js
import React from 'react';
import {
  Paper,
  Card,
  CardContent,
  Typography,
  Grid
} from '@mui/material';

const SummarySection = ({ calculatedData, IVA_RATE }) => {
  // Validación para evitar errores cuando calculatedData está incompleto
  if (!calculatedData || !calculatedData.montoBase) {
    return null;
  }

  // Función helper para formatear moneda
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return '0,00';
    }
    return amount.toLocaleString('es-AR', { minimumFractionDigits: 2 });
  };

  // Función helper para formatear porcentaje
  const formatPercentage = (percentage) => {
    if (percentage === null || percentage === undefined || isNaN(percentage)) {
      return '0,00';
    }
    return percentage.toFixed(2);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Card sx={{ bgcolor: 'success.light' }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            📈 Resumen de Aumentos Progresivos
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">💼 Empresa</Typography>
              <Typography variant="body1">
                {calculatedData.nombreEmpresa || 'No especificada'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">⏰ Horas Mensual</Typography>
              <Typography variant="body1">
                {calculatedData.horasServicio || 'No especificadas'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">💵 Monto Inicial</Typography>
              <Typography variant="body1">
                ${formatCurrency(calculatedData.montoBase)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">💰 Monto Final (Sin IVA)</Typography>
              <Typography variant="body1">
                ${formatCurrency(calculatedData.montoEne)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">💰 Monto Final (Con IVA)</Typography>
              <Typography variant="body1">
                ${formatCurrency((calculatedData.montoEne || 0) * (1 + IVA_RATE))}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="subtitle2">📊 Aumento Total</Typography>
              <Typography variant="body1">
                +{formatPercentage(calculatedData.porcentajeAcumEne)}%
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default SummarySection;